/**
 * @fileoverview Page navigation and redirect validation.
 */

import type {
  ValidationResult,
  NavigateValidationInput,
  RedirectValidationInput,
} from "./types";

/**
 * Validate page navigation options.
 */
export function validateNavigate(
  options: NavigateValidationInput,
): ValidationResult {
  const errors: string[] = [];

  // Path validation
  if (options.path === undefined || options.path === null) {
    errors.push("Navigation path is required");
  } else if (typeof options.path !== "string") {
    errors.push("Navigation path must be a string");
  } else if (options.path.trim() === "") {
    errors.push("Navigation path cannot be empty");
  }

  // Replace validation (optional)
  if (options.replace !== undefined && typeof options.replace !== "boolean") {
    errors.push("Navigation replace option must be a boolean");
  }

  return { valid: errors.length === 0, errors };
}

/**
 * Validate page redirect options.
 */
export function validateRedirect(
  options: RedirectValidationInput,
): ValidationResult {
  const errors: string[] = [];

  // URL validation
  if (options.url === undefined || options.url === null) {
    errors.push("Redirect URL is required");
  } else if (typeof options.url !== "string") {
    errors.push("Redirect URL must be a string");
  } else if (options.url.trim() === "") {
    errors.push("Redirect URL cannot be empty");
  } else {
    // Validate URL format
    try {
      new URL(options.url);
    } catch {
      errors.push(`Invalid redirect URL: "${options.url}"`);
    }
  }

  return { valid: errors.length === 0, errors };
}
